<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'CONTAINER.NEW' | translate | uppercase }}</div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <form [formGroup]="form">

      <div>
        <label>{{ 'PRODUCT.CONTAINER' | translate }} ID</label>
        <input type="text" formControlName="containerId">
      </div>
      <div>
        <label>{{ 'CONTAINER.PRESSURE' | translate }} ({{ market.pressureUom }})</label>
        <input type="text" formControlName="containerMAWP">
      </div>
      <div>
        <label>{{ 'CONTAINER.CAPACITY' | translate }} ({{ market.volumeUom }})</label>
        <input type="text" formControlName="containerMaxCapacity">
      </div>
      <div>
        <label>{{ 'CONTAINER.EMPTY_TARE' | translate }} ({{ market.weightUom }})</label>
        <input type="text" formControlName="containerTareWeight">
      </div>
      <div>
        <label>{{ 'CONTAINER.MODEL_NAME' | translate }}</label>
        <select formControlName="containermodelName">
          @for (containerModel of containerModels; track containerModel) {
            <option value="{{ containerModel.containermodelName }}">{{ containerModel.containermodelName }}</option>
          }
        </select>
      </div>
      <div>
        <label>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</label>
        <select formControlName="transportcompanyName">
          @for (tansportCompany of transportCompanies; track tansportCompany) {
            <option value="{{ tansportCompany.transportcompanyName }}">{{ tansportCompany.transportcompanyName }}</option>
          }
        </select>
      </div>
      <div>
        <label>{{ 'CONTAINER.PUMP_CARRIER' | translate }}</label>
        <input type="checkbox" formControlName="containerPumpCarrier"/>
      </div>

    </form>

    <div class="footer">
      <button (click)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate | uppercase }}</button>
    </div>

  </div>
</div>